import React from "react";
import { useTranslation } from "react-i18next";

import RotatableImage from "../../components/rotatableImage";

export default function MatchView(props) {
  const { t, i18n } = useTranslation("kunduz");

  const { question, stats } = props;

  return (
    <div className="">
      <div className="flex-line flex-jcsb flex-aic">
        <span className="answer-title">{t("suggestedMatch")}</span>
      </div>
      <div
        className="flex-line flex-jcsb flex-aic"
        style={{ marginTop: "16px" }}
      >
        <span className="answer-title2">
          {stats && stats.match_algorithm}, {stats ? "%"+parseInt(stats.ai_accurate_match_score * 100) : 0}, {stats ? "%"+parseInt(stats.ai_score * 100) : 0}
        </span>
        <span className="answer-title2">#{question ? question.id : ""}</span>
      </div>

      {question ? <RotatableImage src={question.media.original} side={props.side} /> : null}

      <div className="action-wrapper">
        <div className="flex-line">
          <div style={{ marginRight: "12px", width: "100%" }}>
            <button
              className="bx--btn btn--kunduz__danger__tertiary btn--kunduz w100"
              type="button"
              onClick={(e) => {
                props.dontMatchCallback(question.qid);
              }}
              disabled={!props.question || props.inProgress}
            >
              {t("dontMatch")}
            </button>
          </div>
          <div style={{ marginLeft: "12px", width: "100%" }}>
            <button
              className="bx--btn btn--kunduz btn--kunduz__secondary w100"
              type="button"
              onClick={(e) => {
                props.matchCallback(question.qid);
              }}
              disabled={!props.question || props.inProgress}
            >
              {t("match")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
